import React from 'react';
import { X } from 'lucide-react';
import Portal from './Portal';

const Modal = ({ isOpen, setIsOpen, children }) => {
    if (!isOpen) {
        return null;
    }
    
    return (
        <Portal>
            <div 
                className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center p-4"
                onClick={() => setIsOpen(false)}
            >
                <div 
                className="relative bg-gray-800 text-gray-300 p-6 sm:p-8 rounded-xl shadow-2xl max-h-[90vh] overflow-y-auto border-2 border-sky-700/50 transform"
                onClick={(e) => e.stopPropagation()}
                >
                <button 
                    onClick={() => setIsOpen(false)}
                    className="absolute top-3 right-3 sm:top-4 sm:right-4 text-gray-400 hover:text-sky-300 hover:cursor-pointer transition-colors z-[51]"
                    aria-label="Close modal"
                >
                    <X size={28} />
                </button>
                    {children}
                </div>
            </div>
        </Portal>
    )
}

export default Modal